import React, { FC } from 'react';
import Typography from '~/shared/components/Typography/Typography';
import { PLPHeroWatermark } from '../PLPHeroWatermark/PLPHeroWatermark';
import styles from '../../PLPHero.module.scss';

export interface PLPHeroContentProps {
    title: string;
    trumpet?: string;
    watermark?: string;
    hasWaterMark?: boolean;
    hasImage?: boolean;
}

export const PLPHeroContent: FC<PLPHeroContentProps> = ({
    title,
    trumpet,
    hasWaterMark,
    watermark,
    hasImage,
}) => {
    const displayWaterMark = hasWaterMark && hasImage;

    return (
        <div className={styles.contentColumn}>
            {displayWaterMark && (
                <div className={styles.waterMarkContainer}>
                    <PLPHeroWatermark watermark={watermark} />
                </div>
            )}

            <div className={styles.headline}>
                {trumpet && (
                    <Typography className={styles.trumpet} as="p" variant="trumpet-XL">
                        {trumpet}
                    </Typography>
                )}

                {title && (
                    <Typography className={styles.title} as="h1" variant="title-M">
                        {title}
                    </Typography>
                )}
            </div>
        </div>
    );
};

export default PLPHeroContent;
